import {Observable} from 'rxjs';
import {Role} from '../models/Role';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ClientRepresentation} from '../models/ClientRepresentation';
import {ConfigService} from './config.service';
import {UserRepresentation} from '../models/UserRepresentation';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root'
})
export class OAuthService {

    constructor(private http: HttpClient, private config: ConfigService) {
    }

    findAllRolesByUser(id: string): Observable<Role[]> {
        return this.http.get<Role[]>(`${this.config.oauthUrl}/usuarios/${id}/papeis/atribuidos`, {
            params: new HttpParams().append('clientId', this.config.clientId)
        });
    }

    findPermissionsByRoleId(id: string): Observable<any> {
        return this.http.get(`${this.config.oauthUrl}/papeis/${id}/permissoes`, {
            params: new HttpParams().append('clientId', this.config.clientId)
        });
    }

    findAllApplications(): Observable<ClientRepresentation[]> {
        return this.http.get<ClientRepresentation[]>(`${this.config.oauthUrl}/aplicacoes`);
    }

    findAllUsers(): Observable<UserRepresentation[]> {
        return this.http.get<UserRepresentation[]>(`${this.config.oauthUrl}/usuarios`);
    }

    updateProfile(user: UserRepresentation): Observable<any> {
        return this.http.put(`${this.config.oauthUrl}/usuarios/${user.id}/perfil`, user);
    }

    updatePassword(user: UserRepresentation): Observable<any> {
        return this.http.put(`${this.config.oauthUrl}/usuarios/${user.id}/nova-senha`, user);
    }

    findUserPhoto(userId: string): Observable<String> {
        return this.http.get(`${this.config.oauthUrl}/usuarios/${userId}/foto`, {responseType: 'text'});
    }

    updateUserPhoto(userId: string, photo: string): Observable<any> {
        return this.http.put(`${this.config.oauthUrl}/usuarios/${userId}/foto`, photo);
    }

}